import { useAppSelector } from '../../hooks/redux'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import {
    SetCodeInitialValues,
    SetCodeOnsubmit,
    SetCodeValidate
} from '../../FormTypes/FSetCode'
import { Strings } from '../../constants/Strings'
import style from './Form.module.css'
import GoButton from '../buttons/GoButton'

interface Props {
    initialValues: SetCodeInitialValues
    validate: SetCodeValidate
    onSubmit: SetCodeOnsubmit
}

const SendCodeForm = ({
        initialValues,
        validate,
        onSubmit
    }: Props
) => {

    const language = useAppSelector<string>(state => state.language.language)

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={onSubmit}
            >
            {({ errors, isSubmitting, values }) => (
                <Form className={style.form} >

                    <ErrorMessage
                        className={style.err}
                        name="code"
                        component="div"
                    />
                    <Field
                        type="text"
                        name="code"
                        autoComplete="code"
                        placeholder={Strings[language ?? 'tm'].otpPlace + "..."}
                        pattern="[0-9]{6,6}"
                        title={Strings[language ?? 'tm'].pattern + ': ' + Strings[language ?? 'tm'].numbers + ' (0-9).'}
                    />

                    <GoButton
                        title={Strings[language ?? 'tm'].confirm}
                        type={"submit"}
                        disabled={isSubmitting}
                        left={false}
                        right={false}
                    />
                </Form>
            )}
        </Formik>
    )
}

export default SendCodeForm